import React, { Component, useState, useRef } from "react";
import "./report.css";
import InputWithClearButton from "../InputWithClearButton";

class ChapterRequirement extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="selectionFilterWrapper chapterRequirement">
        <div className="boundSelector"> &ge; </div>
        <input
          onChange={(e) => this.props.onChange(e)}
          className="inputField"
          type="number"
          defaultValue={this.props.defaultValue}
          // value={this.props.label}
          // onChange={(e) => {}}
          // onClearValue={() => {}}
        />
        <div className="filterSelectorLabelWrapper">
          <div className="filterSelectorLabel w-full">{this.props.label}</div>
        </div>
      </div>
    );
  }
}

export default ChapterRequirement;



// WEBPACK FOOTER //
// ./src/components/reports/ChapterRequirement.jsx